import { Box } from '@helvetia/components/Box'
import { Row } from '@helvetia/components/layout'
import LinkText from '@helvetia/components/LinkText'
import Text from '@helvetia/components/Text'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import AgentService from '../../core/services/agent.service'
import { hasNoRoles } from '../../core/services/auth.service'

interface Props {
  isCalledFrom?: string
}

const ContactBox: React.SFC<WithNamespaces & RouteComponentProps & Props> = ({
  t,
  isCalledFrom,
  history,
}) => {
  if (hasNoRoles() || !AgentService.isAgentOrBroker()) {
    return (
      <Box secondary size="xxs">
        <Row marginBottom="xxs" justifyContent="center">
          <Text as="div" color="secondary" size="s">
            {t('contactMe.questions')}
            <Text as="span" color="secondary" size="sBold">
              {` marine@helvetia.ch`}
            </Text>
          </Text>
        </Row>
        <Row justifyContent="center">
          <LinkText
            text={t('contactMe.beContacted')}
            color="secondary"
            onClick={() => {
              history.push({
                pathname: '/contact-me',
                state: {
                  from: isCalledFrom,
                },
              })
            }}
          />
        </Row>
      </Box>
    )
  }
  return null
}
export default withNamespaces()(withRouter(ContactBox))
